import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f8aa3b94")

_pushScopeId("data-v-f8aa3b94")
const _hoisted_1 = { class: "ftlorder" }
const _hoisted_2 = {
  key: 0,
  class: "ftlorder__loading"
}
const _hoisted_3 = { class: "ftlorder__body" }
const _hoisted_4 = { class: "body__side body__left" }
const _hoisted_5 = { class: "body__side body__right" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_ftl_order_header = _resolveComponent("ftl-order-header")!
  const _component_ftl_order_basic = _resolveComponent("ftl-order-basic")!
  const _component_ftl_order_additional = _resolveComponent("ftl-order-additional")!
  const _component_ftl_order_sender = _resolveComponent("ftl-order-sender")!
  const _component_ttn = _resolveComponent("ttn")!
  const _component_ftl_invoice_for_print = _resolveComponent("ftl-invoice-for-print")!
  const _component_s_print_content = _resolveComponent("s-print-content")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.FTLOrderState.state.is_loading)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _createVNode(_component_s_loader)
        ]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_ftl_order_header, {
            orderId: _ctx.$route.params.order_id,
            onPrint: _ctx.printInvoice
          }, null, 8, ["orderId", "onPrint"]),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              (_ctx.FTLOrderState && _ctx.FTLOrderState.data)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_ftl_order_basic),
                    _createVNode(_component_ftl_order_additional)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode("div", _hoisted_5, [
              (_ctx.FTLOrderState && _ctx.FTLOrderState.data)
                ? (_openBlock(), _createBlock(_component_ftl_order_sender, {
                    key: 0,
                    sender: _ctx.FTLOrderState.data.sender,
                    "additional-service": _ctx.FTLOrderState.data.additional_service
                  }, null, 8, ["sender", "additional-service"]))
                : _createCommentVNode("", true),
              (_ctx.FTLOrderState && _ctx.FTLOrderState.data)
                ? (_openBlock(), _createBlock(_component_ttn, {
                    key: 1,
                    items: _ctx.FTLOrderState.data.stock_delivery_notes,
                    "order-id": _ctx.orderId
                  }, null, 8, ["items", "order-id"]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 64)),
    (_ctx.invoiceForPrintState.data)
      ? (_openBlock(), _createBlock(_component_s_print_content, { key: 2 }, {
          default: _withId(() => [
            _createVNode(_component_ftl_invoice_for_print, {
              invoice: _ctx.invoiceForPrintState.data.data,
              loading: _ctx.invoiceForPrintState.state.is_loading
            }, null, 8, ["invoice", "loading"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
})